/**
 * Shared tabindex handling for the header and mobile navigation.
 *
 * DHNL-6: always *write* the attribute, never remove it. Both menu walkers render an
 * explicit tabindex on every item (`0` at depth 0, `-1` below — see NLDS_Walker and
 * NLDS_Mobile_Walker), and several partials do the same. Removing the attribute to
 * "re-enable" an item leaves it relying on the browser's native tab order, which Safari
 * only grants to form controls unless the user enabled macOS keyboard navigation. The
 * item then silently drops out of the tab order on Safari while staying reachable in
 * Chrome and Firefox — which is why the bug never reproduced internally.
 *
 * @param {Iterable<HTMLElement>|null} elements The elements to update.
 * @param {number} tabIndex The value to write: `0` makes an element tabbable, `-1` skips it.
 */
export const setTabIndex = (elements, tabIndex = -1) => [...(elements || [])].forEach( el => el?.setAttribute( 'tabindex', String( tabIndex ) ) );

export default setTabIndex;
